import { AccountButton } from './AccountButton.jsx';
import { BrandMark } from './BrandMark.jsx';
import { HeaderDateStack } from './HeaderDateStack.jsx';
import { RemindersButton } from './RemindersButton.jsx';
import { ThemeToggleButton } from './ThemeToggleButton.jsx';

/**
 * The page header: brand on the left, date and controls on the right.
 *
 * Composition only. Every child is a module-scope component, never one defined
 * inside this render body, which is the defect that made every profile and
 * onboarding input in the old app lose focus after each keystroke.
 *
 * Audit references prevented here: auth.jsx #2, account.jsx #1, reminders.jsx #4,
 * calories.jsx #12.
 *
 * @param {object} props
 * @param {string} props.dateKey             Today's Eastern calendar date.
 * @param {() => void} props.onOpenReminders
 * @param {() => void} props.onOpenAccount
 * @param {string|null} [props.displayName]
 * @param {string|null} [props.avatarUrl]
 */
export function HeaderBar({
  dateKey,
  onOpenReminders,
  onOpenAccount,
  displayName = null,
  avatarUrl = null,
}) {
  return (
    <header className="app-header">
      <BrandMark />
      <div className="app-header__meta">
        <HeaderDateStack dateKey={dateKey} />
        <div className="app-header__actions">
          <RemindersButton onOpen={onOpenReminders} />
          <ThemeToggleButton />
          <AccountButton
            onOpen={onOpenAccount}
            displayName={displayName}
            photoUrl={avatarUrl}
          />
        </div>
      </div>
    </header>
  );
}
